import BooksSearchStore from '@d-store/modules/books-search';
import BookUserReviewsStore from '@d-store/modules/book-user-reviews';
import CardsStore from '@d-shared/store/cards';
import DiscoverFeedStore from '@d-store/modules/discover-feed';
import SearchStore from '@d-store/modules/search';
import ReviewerSearchStore from '@d-store/modules/reviewer-search';
import FollowingStore from '@d-shared/store/following';

import discoverSearchService from '@d-services/books-search-service/discover-search-service';
import LeaderboardFeedStore from '@d-store/modules/leaderboard-feed';
import leaderboardSearchService from '@d-services/reviewer-search-service/leaderboard-search-service';
import reviewerDirectorySearchService from '@d-services/reviewer-search-service/directory-search-service';
import GenresStore from '@d-shared/store/genres';

export default {
  BookUserReviews: BookUserReviewsStore,
  Cards: CardsStore,
  DiscoverFeed: DiscoverFeedStore,
  'DiscoverFeed/BooksSearch': new BooksSearchStore(discoverSearchService),
  Following: FollowingStore,
  LeaderboardFeed: LeaderboardFeedStore,
  'LeaderboardFeed/ReviewerSearch': new ReviewerSearchStore(leaderboardSearchService),
  'ReviewerDirectory/ReviewerSearch': new ReviewerSearchStore(reviewerDirectorySearchService),
  'ReviewerDirectory/ReviewerSearch/Genres': new GenresStore(),
  Search: SearchStore,
};
